import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Console from '@/views/Frontend/console'
import Register from '@/views/Register'
import ForgetPassword from '@/views/ForgetPassword'
import Home from '@/views/Frontend/Home'
import Product from '@/views/Frontend/Product/comm'
import SnAdd from '@/views/Frontend/Product/sn/add'
import SnUpdate from '@/views/Frontend/Product/sn/update'
import SnIndex from '@/views/Frontend/Product/sn/index'
import SdkLicenceIndex from '@/views/Frontend/Product/sdk/index'
import SdkLicenceAdd from '@/views/Frontend/Product/sdk/add'
import AppliAdd from '@/views/Frontend/Product/appli/add'
import AppliUpdate from '@/views/Frontend/Product/appli/update'
import AppliShare from '@/views/Frontend/Product/appli/appliShare'
import AppliIndex from '@/views/Frontend/Product/appli/index'
import AgentIndex from '@/views/Frontend/Product/agent/index'
import AgentAdd from '@/views/Frontend/Product/agent/add'
import AgentUpdate from '@/views/Frontend/Product/agent/update'
import agentPortMappingAdd from '@/views/Frontend/Product/agent/addPortMapping'
import agentPortMappingUpdate from '@/views/Frontend/Product/agent/updatePortMapping'

import Account from '@/views/Frontend/Account/comm'
import Bill from '@/views/Frontend/Account/bill/index'
import MyOrder from '@/views/Frontend/Account/myOrder/index'
import Charge from '@/views/Frontend/Account/charge/index'
import Coupon from '@/views/Frontend/Account/coupon/index'
import UnprocessedOrder from '@/views/Frontend/Account/unprocessedOrder/index'
import AccountLog from '@/views/Frontend/Account/AccountLog/index'
import Uac from '@/views/Frontend/Uac/comm'
import UacAuthc from '@/views/Frontend/Uac/authc/index'
import UacBasicInfo from '@/views/Frontend/Uac/basicInfo/index'
import UacProducts from '@/views/Frontend/Uac/products/index'
import UacNotice from '@/views/Frontend/Uac/notice/index'
import UacSecure from '@/views/Frontend/Uac/secure/index'
import UacUpdatePassword from '@/views/Frontend/Uac/updatePassword'
import UacLarkXRClientCredentialIndex from '@/views/Frontend/Uac/LarkXRClientCredential/index'

import DevIndex from '@/views/Frontend/Dev/home'
import DevHome from '@/views/Frontend/DevHome'
import Community from '@/views/Frontend/Dev/community/index'
import CommunityIndexAll from '@/views/Frontend/Dev/community/indexAll'
import Activity from '@/views/Frontend/Dev/activity/index'
import QuestionAdd from '@/views/Frontend/Dev/community/question/addQuestion'
import QuestionDetail from '@/views/Frontend/Dev/community/question/detail'

import ContributeAdd from '@/views/Frontend/Dev/community/contribute/addContribute'
import ContributeDetail from '@/views/Frontend/Dev/community/contribute/detail'

import Audit from '@/views/System/Audit/comm'
import EnterpriseCertification from '@/views/System/Audit/EnterpriseCertification/index'

import LocalSnIndex from '@/views/System/LocalSn/index'
import LocalSnUpdate from '@/views/System/LocalSn/update'


Vue.use(Router)
/*const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}*/
// push
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location, onResolve, onReject) {
  // if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {return;})
}
// replace
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace (location, onResolve, onReject) {
  // if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      hidden: true,
      meta: {
        requireLogin: false,
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      hidden: true,
      meta: {
        requireLogin: false,
      }
    },

    {
      path: '/register',
      name: 'Register',
      component: Register,
      hidden: true,
      meta: {
        requireLogin: false,
      }
    },
    {
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: ForgetPassword,
      hidden: true,
      meta: {
        requireLogin: false,
      }
    },
    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive: true,
        requireLogin: true,
        childIsPMenu: false,//子菜单是否是下拉菜单的主菜单
        roleList: [1, 2]
      },
      children: [
        {
          path: '/console',
          name: '控制台',
          component: Console,
          hidden: false,
          iconCls: 'el-icon-discover',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [1, 2]
          },
        },
      ]
    },

    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive: true,
        requireLogin: true,
        childIsPMenu: true,//子菜单是否是下拉菜单的主菜单
        roleList: [1, 2]
      },
      children: [
        {
          path: '/',
          name: '产品',
          component: Product,
          hidden: false,
          iconCls: 'el-icon-pie-chart',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [1, 2]
          },
          children: [
            {
              path: '/sn/add',
              name: '申请云授权',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: SnAdd,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/sn/update',
              name: '修改云授权',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: SnUpdate,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/sn/index',
              name: '授权码',
              hidden: false,
              iconCls: 'el-icon-coin',
              component: SnIndex,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },

            // {
            //   path: '/price/index',
            //   name: '价格详情',
            //   hidden: true,
            //   iconCls: 'el-icon-coin',
            //   component: () => import('@/views/Frontend/Product/priceDetail'),
            //   meta: {
            //     keepAlive: false,
            //     requireLogin: true,
            //     childIsPMenu: false,
            //     roleList: [1, 2]
            //   },
            // },
            {
              path: '/appli/index',
              name: '托管应用',
              hidden: false,
              iconCls: 'el-icon-coin',
              component: AppliIndex,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/sdkLicence/index',
              name: 'SDK授权码',
              hidden: false,
              iconCls: 'el-icon-coin',
              component: SdkLicenceIndex,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/sdkLicence/add',
              name: 'SDK授权码添加',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: SdkLicenceAdd,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/agent/index',
              name: '转发代理',
              hidden: false,
              iconCls: 'el-icon-coin',
              component: AgentIndex,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/agent/add',
              name: '转发代理添加',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: AgentAdd,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/agentPortMapping/add',
              name: '转发代理端口添加',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: agentPortMappingAdd,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/agentPortMapping/update',
              name: '转发代理端口编辑',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: agentPortMappingUpdate,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/agent/update',
              name: '转发代理更改',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: AgentUpdate,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/appli/add',
              name: '托管应用添加',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: AppliAdd,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/appli/update',
              name: '编辑托管应用',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: AppliUpdate,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/appli/share',
              name: '分享托管应用',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: AppliShare,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/appli/replaceLogo',
              name: '替换启动Logo',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: () => import('../views/Frontend/Product/appli/replaceLogo.vue'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },

            {
              path: '/support/index',
              name: '联系我们',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: () => import('../views/Frontend/Uac/Support/index.vue'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            }
          ]
        },
      ]
    },

    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive: true,
        requireLogin: true,
        childIsPMenu: true,//子菜单是否是下拉菜单的主菜单
        roleList: [1, 2]
      },

      children: [
        {
          path: '/',
          name: '费用',
          component: Account,
          hidden: false,
          iconCls: 'el-icon-discount',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [1, 2]
          },
          children: [
            {
              path: '/price/index',
              name: '价格详情',
              hidden: false,
              iconCls: 'el-icon-coin',
              component: () => import('@/views/Frontend/Product/priceDetail'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/account/bill',
              name: '账单总览',
              hidden: false,
              iconCls: 'el-icon-pie-chart',
              component: Bill,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/account/myOrder',
              name: '我的订单',
              hidden: false,
              iconCls: 'el-icon-data-line',
              component: MyOrder,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            /* {
               path: '/account/UnprocessedOrder',
               name: '待支付订单',
               hidden: false,
               iconCls: 'el-icon-data-line',
               component:  UnprocessedOrder,
               meta: {
                 keepAlive: false,
                 requireLogin: true,
                 childIsPMenu: false,
                 roleList: [1, 2, 30,31]
               },
             },*/
            {
              path: '/account/accountLog',
              name: '收支明细',
              hidden: false,
              iconCls: 'el-icon-data-line',
              component: AccountLog,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/account/charge',
              name: '充值',
              hidden: false,
              iconCls: 'el-icon-data-line',
              component: Charge,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
        /*    {
              path: '/account/coupon',
              name: '优惠券',
              hidden: false,
              iconCls: 'el-icon-data-line',
              component: Coupon,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },*/
          ]
        },
      ]
    },

    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive: true,
        requireLogin: true,
        childIsPMenu: true,//子菜单是否是下拉菜单的主菜单
        roleList: [1, 2]
      },
      children: [
        {
          path: '/',
          name: '账号',
          component: Uac,
          hidden: false,
          iconCls: 'el-icon-user',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [1, 2]
          },
          children: [
            {
              path: '/uac/basicInfo',
              name: '基本信息',
              hidden: false,
              iconCls: 'el-icon-pie-chart',
              component: UacBasicInfo,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/uac/updatePassword',
              name: '修改密码',
              hidden: true,
              iconCls: 'el-icon-pie-chart',
              component: UacUpdatePassword,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/uac/authc',
              name: '账号认证',
              hidden: false,
              iconCls: 'el-icon-data-line',
              component: UacAuthc,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [2]
              },
            },
            {
              path: '/uac/secure',
              name: '安全设置',
              hidden: false,
              iconCls: 'el-icon-data-line',
              component: UacSecure,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/uac/products',
              name: '用户配额',
              hidden: false,
              iconCls: 'el-icon-data-line',
              component: UacProducts,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
            {
              path: '/uac/notice',
              name: '站内消息',
              hidden: false,
              iconCls: 'el-icon-data-line',
              component: UacNotice,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },

            {
              path: '/uac/larkXRClientCredential',
              name: '密钥管理',
              hidden: true,
              iconCls: 'el-icon-data-line',
              component: UacLarkXRClientCredentialIndex,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1, 2]
              },
            },
          ]
        },
      ]
    },

    {
      path: '',
      component: DevHome,
      hidden: true,
      meta: {
        keepAlive: true,
        requireLogin: true,
        childIsPMenu: true,//子菜单是否是下拉菜单的主菜单
        roleList: [1, 2]
      },
      children: [
        {
          path: '/activity/index',
          name: '活动一览',
          hidden: true,
          iconCls: 'el-icon-coin',
          component: Activity,
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [1, 2]
          },
        },
        {
          path: '/dev/index',
          name: '社区一览',
          hidden: true,
          iconCls: 'el-icon-coin',
          component: DevIndex,
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [1, 2, 30,31]
          },
        },
        {
          path: '/community/index',
          name: '社区一览(分类)',
          hidden: true,
          iconCls: 'el-icon-coin',
          component: Community,
          meta: {
            keepAlive: false,
            requireLogin: false,
            childIsPMenu: false,
            roleList: [1, 2, 30,31]
          },
        },
        {
          path: '/community/index/all',
          name: '社区一览(一览)',
          hidden: true,
          iconCls: 'el-icon-coin',
          component: CommunityIndexAll,
          meta: {
            keepAlive: false,
            requireLogin: false,
            childIsPMenu: false,
            roleList: [1, 2, 30,31]
          },
        },
        {
          path: '/question/add',
          name: '提问',
          hidden: true,
          iconCls: 'el-icon-coin',
          component: QuestionAdd,
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [1, 2, 30,31]
          },
        },
        {
          path: '/question/detail',
          name: '问答详情',
          hidden: true,
          iconCls: 'el-icon-coin',
          component: QuestionDetail,
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [1, 2, 30,31]
          },


        },

        {
          path: '/contribute/add',
          name: '写文章',
          hidden: true,
          iconCls: 'el-icon-coin',
          component: ContributeAdd,
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [1, 2, 30,31]
          },
        },
        {
          path: '/contribute/detail',
          name: '文章详情',
          hidden: true,
          iconCls: 'el-icon-coin',
          component: ContributeDetail,
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [1, 2, 30,31]
          },


        },
      ]
    },


    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive: true,
        requireLogin: true,
        childIsPMenu: true,//子菜单是否是下拉菜单的主菜单
        roleList: [30,31]
      },
      children: [
        {
          path: '/',
          name: '审核',
          component: Audit,
          hidden: false,
          iconCls: 'el-icon-discount',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [30,31]
          },
          children: [
            {
              path: '/audit/ec',
              name: '企业认证',
              hidden: false,
              iconCls: 'el-icon-pie-chart',
              component: EnterpriseCertification,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },
          ]
        },
      ]
    },
    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive: true,
        requireLogin: true,
        childIsPMenu: true,//子菜单是否是下拉菜单的主菜单
        roleList: [30,31] // 1个人用户,2企业用户,30,31系统用户(管理员)
      },
      children: [
        {
          path: '/',
          name: '消息通知',
          component: Audit,
          hidden: false,
          iconCls: 'el-icon-message',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [30,31]
          },
          children: [
            {
              path: '/notify/all',
              name: '全部',
              hidden: false,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Notify'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },
            {
              path: '/notify/add',
              name: '添加消息',
              hidden: true,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Notify/add'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },
            {
              path: '/notify/update',
              name: '修改消息',
              hidden: true,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Notify/add'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },
          ]
        },
      ]
    },
    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: true,
        roleList: [30,31]
      },
      children: [
        {
          path: '/',
          name: '资讯',
          component: Audit,
          hidden: false,
          iconCls: 'el-icon-edit-outline',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [30,31]
          },
          children: [
            {
              path: '/information',
              name: '资讯列表',
              hidden: false,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Release/information/index'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },{
              path: '/infomation/detail',
              name: '资讯详情',
              hidden: true,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Release/information/detail'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },{
              path: '/information/add',
              name: '资讯发布',
              hidden: true,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Release/information/add'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },{
              path: '/information/edit',
              name: '资讯编辑',
              hidden: true,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Release/information/edit'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },/*,{
              path: '/blog',
              name: '专栏博客',
              hidden: false,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Release/blog/index'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },{
              path: '/blog/add',
              name: '专栏博客发布',
              hidden: true,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Release/blog/add'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },{
              path: '/blog/detail',
              name: '专栏博客详情',
              hidden: true,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Release/information/detail'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },*/
            {
              path: '/userManage/sn',
              name: '查看授权码',
              component: () => import('../views/System/UserManage/sn.vue'),
              hidden: true,
              iconCls: 'el-icon-user',
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              }
            },{
              path: '/userManage/snUpdate',
              name: '修改授权码',
              component: () => import('../views/System/UserManage/snUpdate.vue'),
              hidden: true,
              iconCls: 'el-icon-user',
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              }
            },{
              path: '/userManage/appli',
              name: '查看托管应用',
              component: () => import('../views/System/UserManage/appli.vue'),
              hidden: true,
              iconCls: 'el-icon-user',
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              }
            }
          ]
        },
      ]
    },

    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: true,
        roleList: [30,31]
      },
      children: [
        {
          path: '/',
          name: '报表下载',
          component: Audit,
          hidden: false,
          iconCls: 'el-icon-download',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [30,31]
          },
          children: [
            {
              path: '/payLog',
              name: '充值记录',
              hidden: false,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/PayLog/index'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },
          ]
        },
      ]
    },
/*    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: true,
        roleList: [30,31]
      },
      children: [
        {
          path: '/',
          name: '实例管理',
          component: Audit,
          hidden: false,
          iconCls: 'el-icon-document-add',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [30,31]
          },
          children: [
            {
              path: '/instance',
              name: '发行实例',
              hidden: false,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Instance/createInstance'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },{
              path: '/instance/list',
              name: '实例一览',
              hidden: false,
              iconCls: 'el-icon-pie-chart',
              component: () => import('@/views/System/Instance/instanceManage'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            },
          ]
        },
      ]
    },*/
    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: true,
        roleList: [1,2,30,31,60]
      },
      children: [
        {
          path: '/',
          name: '发票管理',
          component: Audit,
          hidden: false,
          iconCls: 'el-icon-tickets',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [1,2,30,31,60]
          },
          children: [
            {
              path: '/invoice',
              name: '开发票',
              component: () => import('../views/System/Invoice/index.vue'),
              hidden: false,
              iconCls: 'el-icon-tickets',
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: true,
                roleList: [1,2,60]
              },
            },{
              path: '/invoice/approve',
              name: '发票审批',
              component: () => import('../views/System/Invoice/approve.vue'),
              hidden: false,
              iconCls: 'el-icon-tickets',
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: true,
                roleList: [30,31]
              },
            },
            {
              path: '/invoice/info',
              name: '发票信息管理',
              component: () => import('../views/System/Invoice/invoiceInfo.vue'),
              hidden: true,
              iconCls: 'el-icon-tickets',
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1,2]
              }
            },{
              path: '/invoice/create',
              name: '发票索取',
              component: () => import('../views/System/Invoice/create.vue'),
              hidden: true,
              iconCls: 'el-icon-tickets',
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1,2]
              }
            },{
              path: '/invoice/detail',
              name: '发票详情',
              component: () => import('../views/System/Invoice/invoiceDetail.vue'),
              hidden: true,
              iconCls: 'el-icon-tickets',
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [1,2]
              }
            },
            ,{
              path: '/localSn/update',
              name: '本地授权Renew',
              hidden: true,
              iconCls: 'el-icon-coin',
              component: LocalSnUpdate,
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [31]
              },
            }
          ]
        },
      ]
    },
/*    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: true,
        roleList: [30,31]
      },
      children: [
        {
          path: '/',
          name: '系统设置',
          component: Audit,
          hidden: false,
          iconCls: 'el-icon-setting',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: true,
            roleList: [30,31]
          },
          children: [
            {
              path: '/setting/index',
              name: '系统设置',
              hidden: false,
              iconCls: 'el-icon-setting',
              component: () => import('@/views/System/SysSetting/index'),
              meta: {
                keepAlive: false,
                requireLogin: true,
                childIsPMenu: false,
                roleList: [30,31]
              },
            }
          ]
        },
      ]
    },*/
    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: false,
        roleList: [30,31]
      },
      children: [
        {
          path: '/extraProd',
          name: '扣费设置',
          component: () => import('../views/System/ExtraProd/index.vue'),
          hidden: false,
          iconCls: 'el-icon-money',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [30,31]
          }
        }
      ]
    },

    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: false,
        roleList: [31]
      },
      children: [{
        path: '/localSn/index',
        name: '本地授权',
        component: () => import('../views/System/LocalSn/index.vue'),
        hidden: false,
        iconCls: 'el-icon-data-board',
        meta: {
          keepAlive: false,
          requireLogin: true,
          childIsPMenu: false,
          roleList: [31]
        }
      }
      ]
    },
    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: false,
        roleList: [30,31]
      },
      children: [
        {
          path: '/userManage',
          name: '用户管理',
          component: () => import('../views/System/UserManage/userManage.vue'),
          hidden: false,
          iconCls: 'el-icon-user',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [30,31]
          }
        }
      ]
    },
    {
      path: '',
      component: Home,
      hidden: false,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: false,
        roleList: [30,31]
      },
      children: [
        {
          path: '/dataBoard',
          name: '数据看板',
          component: () => import('../views/System/DataBoard/Overview/index.vue'),
          hidden: false,
          iconCls: 'el-icon-data-board',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [30,31]
          },
        },
      ]
    },
    {
      path: '',
      component: Home,
      hidden: true,
      meta: {
        keepAlive:  true,
        requireLogin: true,
        childIsPMenu: true,
        roleList: [30,31]
      },
      children: [{
          path: '/dataBoard/developer',
          name: '开发者分析',
          component: () => import('../views/System/DataBoard/Developer/index.vue'),
          hidden: true,
          iconCls: 'el-icon-data-board',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [30,31]
          }
        },{
          path: '/dataBoard/product',
          name: '产品分析',
          component: () => import('../views/System/DataBoard/Product/index.vue'),
          hidden: true,
          iconCls: '',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [30,31]
          }
        },{
        path: '/dataBoard/operations',
        name: '运营分析',
        component: () => import('../views/System/DataBoard/Operations/index.vue'),
        hidden: true,
        iconCls: '',
        meta: {
          keepAlive: false,
          requireLogin: true,
          childIsPMenu: false,
          roleList: [30,31]
        }
      },{
          path: '/dataBoard/terminal',
          name: '终端分析',
          component: () => import('../views/System/DataBoard/Terminal/index.vue'),
          hidden: true,
          iconCls: '',
          meta: {
            keepAlive: false,
            requireLogin: true,
            childIsPMenu: false,
            roleList: [30,31]
          }
        }
      ]
    },


  ]
})
